import { render } from "./FontsizeSwitcher.vue?vue&type=template&id=3dfe5834&scoped=true&ts=true"
import script from "./FontsizeSwitcher.vue?vue&type=script&lang=ts"
export * from "./FontsizeSwitcher.vue?vue&type=script&lang=ts"

import "./FontsizeSwitcher.vue?vue&type=style&index=0&id=3dfe5834&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dfe5834"]])

export default __exports__